<script>
  import PaxrayMainLogo from "lib/components/common/logos/PaxrayMainLogo.svelte";
  import { onMount } from "svelte";
  import { fly } from "svelte/transition";
  import { fade } from "svelte/transition";
  import LoginFooter from "./LoginFooter.svelte";

  let animate = false;

  onMount(() => {
    animate = true;
  });
</script>

<div class="login-content-container">
  <div class="login-content">
    {#if animate === true}
      <div in:fade class="login-image">
        <PaxrayMainLogo />
      </div>
      <div class="login-content__text">
        <h1 in:fly={{ y: -20, delay: 400 }}>Software</h1>
        <h2 in:fly={{ y: -20, delay: 600 }}>Suite</h2>
      </div>
    {/if}
  </div>
  <LoginFooter />
</div>

<style>
  .login-content-container {
    --login-side-nav-width: clamp(24rem, 22vw, 28rem);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: var(--pax-gradient-vertical-new);
    color: var(--pax-white);
    position: fixed;
    top: 0;
    width: calc(100vw - var(--login-side-nav-width));
    left: var(--login-side-nav-width);
    overflow: hidden;
  }

  .login-content-container::after {
    content: "";
    position: absolute;
    inset: 0;
    background-image: url("/img/bg/noise.svg");
    background-size: 22rem 22rem;
    opacity: 0.15;
    mix-blend-mode: soft-light;
    pointer-events: none;
  }

  .login-content {
    display: flex;
    align-items: flex-start;
    gap: 1.5rem;
    position: relative;
    z-index: 1;
  }

  .login-image {
    width: 100%;
    max-width: 19rem;
  }

  .login-content__text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 0.2rem;
    padding-top: 0.3rem;
  }

  h1 {
    line-height: 0.75;
    font-weight: 700;
    font-size: var(--m, 1rem);
  }
  h2 {
    font-weight: 200;
    font-size: var(--m, 0.75rem);
  }
</style>
